module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"users":{"tile":{"goto_user":"To profile","send_message":"Send message"}}}}}}')
  delete Component.options._Ctor
}
